"use strict";
var core_1 = require('@angular/core');
exports.makeDecorator = core_1.__core_private__.makeDecorator;
exports.reflector = core_1.__core_private__.reflector;
//# sourceMappingURL=core_private.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/router-deprecated/core_private.js
 ** module id = 453
 ** module chunks = 0
 **/